"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@dc/ui/components";
import { useTranslations } from "next-intl";
interface EmsQuotaErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function EmsQuotaErrorModal(t0) {
  const $ = _c(22);
  const {
    isOpen,
    onClose
  } = t0;
  const t = useTranslations("ems_quota");
  if (!isOpen) {
    return null;
  }
  let t1;
  if ($[0] !== onClose) {
    t1 = open => !open && onClose();
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("project_limit_reached_title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <ModalHeader>{t2}</ModalHeader>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("project_limit_reached_body");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <ModalBody className="text-default-700 text-sm"><p>{t4}</p></ModalBody>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("continue_browsing");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onClose || $[13] !== t6) {
    t7 = <ModalFooter><Button color="primary" onPress={onClose}>{t6}</Button></ModalFooter>;
    $[12] = onClose;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t5 || $[17] !== t7) {
    t8 = <ModalContent>{t3}{t5}{t7}</ModalContent>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t1 || $[20] !== t8) {
    t9 = <Modal isOpen={true} size="md" onOpenChange={t1} skipBack={true}>{t8}</Modal>;
    $[19] = t1;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}